module.exports = __webpack_public_path__ + "media/images/emoticons/bread-007459fc182f9341a035c3d9a6062520.gif";